import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/seo/SEO";
import { LayoutGrid } from "@/components/ui/layout-grid";
import { useScrollTracking } from "@/hooks/useScrollTracking";
import { SocialShareWidget } from "@/components/SocialShareWidget";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

// Import portfolio images
import classicBrickHouse from "/lovable-uploads/c16646ef-affe-4865-b999-e6763835ac35.png";
import eveningHouse from "/lovable-uploads/6d05ad2d-1468-41a7-b846-ece8ec2c7fef.png";
import flatRoofAerial from "/lovable-uploads/4639388a-6854-4a1a-9d52-e5cc989bb20f.png";
import suburbanRoof from "/lovable-uploads/f3f7114c-1fa9-43b8-b7f5-ede96bac593f.png";
import modernWhiteHouse from "/lovable-uploads/98c4dfa8-d947-44a2-8913-59e8a4d08e2e.png";
import tileRoofPanels from "/lovable-uploads/abd08879-1e0f-41ab-8cdb-a146fa5e317e.png";
import curvedRoofDetail from "/lovable-uploads/f3c35a25-a97f-4ba4-a74f-720d09eb06ce.png";
import gardenHousePanels from "/lovable-uploads/37b3bb75-2735-40ce-830a-737d84d90d3f.png";
import blueSkyInstallation from "/lovable-uploads/9ad545d6-8e7e-4258-bf0b-6462ce0dd2f2.png";
const ProjectOne = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Klassieke Baksteen Woning
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Perfecte harmonie tussen traditionele architectuur en moderne duurzame technologie. 
        Zorgvuldige installatie met respect voor het originele karakter.
      </p>
    </div>;
};
const ProjectTwo = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Avondopname Installatie
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Ook in de avonduren een prachtig beeld. Onze installaties integreren 
        naadloos met de dakstructuur voor een tijdloos design.
      </p>
    </div>;
};
const ProjectThree = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Plat Dak Luchtfoto
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Optimale hoek en oriëntatie op platte daken voor maximale opbrengst. 
        Windbestendige bevestiging volgens alle veiligheidsnormen.
      </p>
    </div>;
};
const ProjectFour = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Voorstedelijk Dak
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Moderne zonnepanelen geïntegreerd op een klassiek voorstedelijk dak. 
        Discrete installatie met optimale energieopbrengst.
      </p>
    </div>;
};
const ProjectFive = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Moderne Witte Woning
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Strakke lijnen en perfecte afwerking op deze moderne witte woning. 
        Optimale esthetiek en hoge prestaties in één ontwerp.
      </p>
    </div>;
};
const ProjectSix = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Pannen Dak Detail
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Vakkundige installatie op pannendak met perfecte dakintegratie. 
        Respect voor traditionele dakbedekking met moderne technologie.
      </p>
    </div>;
};
const ProjectSeven = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
        Gebogen Dak Installatie
      </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
        Complexe dakstructuur met vakkundige paneel plaatsing. 
        Elke uitdaging wordt aangegaan met precisie en expertise.
      </p>
    </div>;
};
const ProjectEight = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">Duitsland</p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">Zonnepanelen maximaliseren de totale energieopbrengst. Slimme integratie voor complete energieoplossingen.</p>
    </div>;
};
const ProjectNine = () => {
  return <div>
      <p className="font-bold md:text-4xl text-xl text-white">
    </p>
      <p className="font-normal text-base my-4 max-w-lg text-neutral-200">
    </p>
    </div>;
};
const portfolioCards = [{
  id: 1,
  content: <ProjectOne />,
  className: "md:col-span-2",
  thumbnail: classicBrickHouse
}, {
  id: 2,
  content: <ProjectTwo />,
  className: "col-span-1",
  thumbnail: eveningHouse
}, {
  id: 3,
  content: <ProjectThree />,
  className: "col-span-1",
  thumbnail: flatRoofAerial
}, {
  id: 4,
  content: <ProjectFour />,
  className: "md:col-span-2",
  thumbnail: suburbanRoof
}, {
  id: 5,
  content: <ProjectFive />,
  className: "col-span-1",
  thumbnail: modernWhiteHouse
}, {
  id: 6,
  content: <ProjectSix />,
  className: "col-span-1",
  thumbnail: tileRoofPanels
}, {
  id: 7,
  content: <ProjectSeven />,
  className: "col-span-1",
  thumbnail: curvedRoofDetail
}, {
  id: 8,
  content: <ProjectEight />,
  className: "md:col-span-2",
  thumbnail: gardenHousePanels
}, {
  id: 9,
  content: <ProjectNine />,
  className: "col-span-1",
  thumbnail: blueSkyInstallation
}];
export default function Portfolio() {
  useScrollTracking();
  return <>
      <SEO title="Portfolio - Zonnepaneel Projecten | SOL-VI" description="Bekijk onze uitgevoerde zonnepaneel projecten in Gelderland. Professionele installaties met oog voor detail in Elst en omgeving." type="website" />
      <Header />
      
      <main className="min-h-screen">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/10 via-background to-secondary/10 py-16 lg:py-24">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Onze Projecten
            </h1>
            <p className="text-lg lg:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
              Ontdek de kwaliteit van onze zonnepaneel installaties in Gelderland. 
              Van klassieke woningen tot moderne nieuwbouw - elk project wordt met 
              vakmanschap en oog voor detail uitgevoerd.
            </p>
          </div>
        </section>

        {/* Portfolio Grid */}
        <section className="py-16 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">Portfolio</h2>
              
            </div>
            
            <LayoutGrid cards={portfolioCards} />
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-primary/5">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Uw Project Start Hier</h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Wilt u ook een professionele zonnepaneel installatie? 
              Vraag een vrijblijvende offerte aan en word onderdeel van onze succesverhalen.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/offerte">
                <Button size="lg" className="group">
                  Offerte Aanvragen
                  <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" size="lg">
                  Contact Opnemen
                </Button>
              </Link>
            </div>
          </div>
        </section>
        
        {/* Social Share */}
        <div className="container mx-auto px-4 py-8">
          <SocialShareWidget title="SOL-VI Portfolio - Zonnepaneel Projecten" description="Bekijk onze professionele zonnepaneel installaties in Gelderland" variant="follow" size="lg" />
        </div>
      </main>
      
      <Footer />
    </>;
}